import { useWorkspaceStore } from "../../store/WorkspaceStore";
import { I18n } from "@/i18n/I18n";
import { useFusaOrganizationStore } from "../../store/FusaOrganizationStore";
import { FileSubjectTypes } from "@/types/fileTypes";
import { CreateHierarchyModelButton } from "../buttons/CreateHierarchyModelButton";
import { WorkspaceCards } from "./WorkspaceCards";
import { useShallow } from "zustand/react/shallow";

export function EditableWorkspaceCards(props: { fusaOrganizationId?: string }) {
  const { fusaOrganizationId } = props;
  const workspaces = useWorkspaceStore(useShallow(state => state.workspaces));
  const filteredWorkspaces = fusaOrganizationId ? workspaces.filter(workspace => workspace.ownerFusaOrgId === fusaOrganizationId) : workspaces;

  return (
    <div>
      <CreateWorkspaceButton fusaOrganizationId={fusaOrganizationId} />
      <WorkspaceCards workspaces={filteredWorkspaces} />  
    </div>
  );
}

function CreateWorkspaceButton(props: { fusaOrganizationId?: string }) {
  const { fusaOrganizationId } = props;
  const fusaOrganizations = useFusaOrganizationStore(state => state.fusaOrganizations);
  const createWorkspace = useWorkspaceStore(state => state.createWorkspace);
  const refetchWorkspace = useWorkspaceStore(state => state.refetchWorkspace);

  const handleCreate = async (title: string, description: string, ownerFusaOrgId: string): Promise<string | undefined> => {
    const response = await createWorkspace({
      title,
      description,
      ownerFusaOrgId,
    });
    return response.workspace?.id;
  };

  return (
    <CreateHierarchyModelButton 
      createModel={(title, description, ownerFusaOrgId) => handleCreate(title, description, ownerFusaOrgId)} 
      modelLabel={I18n.get('workspace')} 
      refetchSubject={refetchWorkspace} 
      subjectType={FileSubjectTypes.WORKSPACE}
      parents={fusaOrganizations}
      parentLabel={I18n.get('organization')}
      defaultParentId={fusaOrganizationId}
    />
  );
}
